class PrintProduct {
    static basePrice(currency, conversions, printProfileName) {
        const conversionTable = conversions.filter(conversion => {
            if (printProfileName === 'Print') {
                return conversion.data.Name === 'Print (Base)';
            } else {
                return conversion.data.Name === printProfileName;
            }
        })[0];

        return conversionTable.data[currency.toUpperCase()];
    }

    static calculatedPrice(size, frame, conversions, printProfileName) {
        const currencies = ['usd', 'gbp', 'aud', 'cad', 'eur'];
        let prices = {};

        for (let currency of currencies) {
            let price = PrintProduct.basePrice(currency, conversions, printProfileName);
            if (printProfileName === 'Print') {
                const sizeModifier = PrintProduct.sizePriceModifier(currency, size, conversions);
                const frameModifier = PrintProduct.framePriceModifier(currency, size, conversions);

                price += sizeModifier;

                if (frame !== 'None') {
                    price += frameModifier;
                }
            }

            prices[currency] = price;
        }

        return prices;
    }

    static compiledId(reference, size, frame) {
        return `${reference}-${size}-${frame}`.toLowerCase();
    }

    static description(size, frame) {
        let result;

        if (frame === 'None') {
            result = 'Print, Unframed';
        } else {
            result = `Print, ${frame} Frame`;
        }

        if (size !== 'Special') {
            result = `${result}, ${PrintProduct.prototype.sizeLabels[size]}`;
        }

        return result;
    }

    static entriesForPriceTable(data, server_root) {
        let result = [];

        PrintProduct.prototype.frameOptions.forEach(frame => {
            if (data.Price_Profile_Name[0] === 'Print' || (data.Price_Profile_Name[0] !== 'Print' && frame === 'None')) {
                data.Sizes.forEach(size => {
                    result.push({
                        id: PrintProduct.compiledId(data.Reference, size, frame),
                        price: (
                            (data.Discount_Price_Profile && data.Discount_Price_Profile.length > 0) ?
                                PrintProduct.calculatedPrice(size, frame, data.Discount_Price_Profile[0].data.Conversions, data.Price_Profile_Name[0])
                                :
                                PrintProduct.calculatedPrice(size, frame, data.Price_Profile[0].data.Conversions, data.Price_Profile_Name[0])
                        ),
                        url: `${server_root}/data/products/${data.Reference}.json`,
                    });
                });
            }
        });

        return result;
    }

    static framePriceModifier(currency, size, conversions) {
        const conversionTable = conversions.filter(conversion => {
            return conversion.data.Name === `Print Modifier (Frame - ${size})`;
        })[0];

        return conversionTable.data[currency.toUpperCase()];
    }

    static sizePriceModifier(currency, size, conversions) {
        if (size === 'S') {
            return 0;
        }

        const conversionTable = conversions.filter(conversion => {
            return conversion.data.Name === `Print Modifier (Size - ${size})`;
        })[0];

        return conversionTable.data[currency.toUpperCase()];
    }
}

PrintProduct.prototype.frameOptions = [
    'None', 'Black', 'White', 'Natural', 'Brown'
];

PrintProduct.prototype.sizeLabels = {
    'S': 'Small',
    'M': 'Medium',
    'L': 'Large',
    'XL': 'X-Large'
};

module.exports = PrintProduct;
